export default {
  beforeRouteEnter (to, from, next) {
    window.document.body.style.background =
      'linear-gradient(-179deg, #C1D5F7 0%, #91AFEB 100%)'
    next()
  },
  beforeRouteLeave (to, from, next) {
    window.document.body.style.background = ''
    next()
  }
}
